import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function Author() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section ref={ref} className="relative py-32 px-6 bg-dark-900">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative w-full h-[500px] rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/55de03a58447b22c9804f3000d5f2dfc/9213ec1d98537b8a6836533b82f7cb9c.jpeg"
                alt="Johann Alvarez"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              
              {/* Award badge */}
              <div className="absolute bottom-6 left-6 right-6 bg-dark-900/90 backdrop-blur-sm border border-gold-500/50 rounded-lg p-4">
                <div className="flex items-center gap-3">
                  <i className="ri-award-line text-3xl text-gold-400"></i>
                  <div className="text-left">
                    <p className="font-sans text-xs text-gold-400 uppercase tracking-wider">Catholics Music Awards 2025</p>
                    <p className="font-serif text-sm text-warm-100">Mejor Cantante Masculino</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h2 className="font-serif text-5xl md:text-6xl text-gold-400 mb-6">
              Sobre el Autor
            </h2>

            <h3 className="font-serif text-4xl text-warm-100 mb-8">
              Johann Alvarez
            </h3>

            <div className="space-y-6 mb-10">
              <p className="font-sans text-lg text-warm-200 leading-relaxed">
                <strong className="text-warm-100">Evangelizador, cantautor y misionero</strong> con una profunda vocación de llevar el mensaje de Cristo a través de la música y la palabra.
              </p>

              <div className="bg-dark-800 border border-gold-500/30 rounded-lg p-6 space-y-4">
                <div className="flex items-center gap-4">
                  <div className="flex items-center justify-center w-12 h-12 bg-gold-500/10 rounded-full">
                    <i className="ri-trophy-line text-2xl text-gold-400"></i>
                  </div>
                  <div>
                    <p className="font-sans text-warm-100 font-semibold">
                      Ganador Catholics Music Awards 2025
                    </p>
                    <p className="font-sans text-sm text-warm-200">
                      Mejor Cantante Masculino desde el Vaticano
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="flex items-center justify-center w-12 h-12 bg-gold-500/10 rounded-full">
                    <i className="ri-time-line text-2xl text-gold-400"></i>
                  </div>
                  <div>
                    <p className="font-sans text-warm-100 font-semibold">
                      32 años de evangelización
                    </p>
                    <p className="font-sans text-sm text-warm-200">
                      Dedicados a compartir el amor de Dios
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="flex items-center justify-center w-12 h-12 bg-gold-500/10 rounded-full">
                    <i className="ri-earth-line text-2xl text-gold-400"></i>
                  </div>
                  <div>
                    <p className="font-sans text-warm-100 font-semibold">
                      15 años como misionero
                    </p>
                    <p className="font-sans text-sm text-warm-200">
                      Llevando esperanza a diferentes naciones
                    </p>
                  </div>
                </div>
              </div>

              <p className="font-serif text-xl text-warm-200 italic leading-relaxed">
                "Mi misión es acompañarte en este camino de transformación, donde cada día es una oportunidad para encontrarte más profundamente con Dios."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}